// src/components/Footer.js
import { NavLink } from "react-router-dom";
import footerlogo from "../assets/images/logo.png";
import data from "../data/homeContent.json";
import { COMPANY_NAME, resolve } from "../constants";

function Footer() {
  const contact = data.find((d) => d.id === 6);

  return (
    <footer>
      <section className="footer-section">
        <div className="container">
          <div className="row">

            {/* Logo */}
            <div className="col-md-3 col-sm-6 mb-4 text-center text-md-start">
              <img src={footerlogo} alt="Logo" className="me-2 logo" />
            </div>

            {/* Links 1 */}
            <div className="col-md-3 col-sm-6 mb-4">
              <h5 className="footer-heading">Important Links</h5>
              <ul className="footer-links">
                <li>
                  <NavLink to="/" className="footer-link">Home</NavLink>
                </li>
                <li>
                  <NavLink to="/about" className="footer-link">About</NavLink>
                </li>
                <li>
                  <NavLink to="/legal" className="footer-link">Legal</NavLink>
                </li>
                <li>
                  <NavLink to="/contact" className="footer-link">Contact</NavLink>
                </li>
              </ul>
            </div>

            {/* Links 2 */}
            <div className="col-md-3 col-sm-6 mb-4">
              <h5 className="footer-heading">Products</h5>
              <ul className="footer-links">
                <li>
                  <NavLink to="/business-plan" className="footer-link">
                    Business Plan
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/crop-booster" className="footer-link">
                    Crop Booster
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/lady-grow" className="footer-link">
                    Lady Grow
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div className="col-md-3 col-sm-6 mb-4">
              <h5 className="footer-heading">Contact Us</h5>
              {contact && (
                <>
                  <p>{resolve(contact.email)}</p>
                  <p>{contact.phone}</p>
                  <p>{contact.address}</p>
                </>
              )}
            </div>

          </div>
        </div>
      </section>

      <p className="text-center">
        &copy; {new Date().getFullYear()} {COMPANY_NAME} | All Rights Reserved
      </p>
    </footer>
  );
}

export default Footer;